import { Box, Tooltip } from "@mui/material";
import { WasteManifestSource } from "generated-graphql/graphql";

import { SOURCE_COLOR, SOURCE_LABEL } from "./manifestSourceDisplay";

export interface FieldSourceDotProps {
  source: WasteManifestSource;
  /** Click to open the per-field provenance popover. */
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  /** Override the hover tooltip. Defaults to "From <source>". */
  tooltip?: string;
}

/**
 * Tiny color-by-source dot for a read-only field. The tooltip names the source;
 * clicking opens the provenance popover. Rendered inline beside a field label.
 */
export function FieldSourceDot({ source, onClick, tooltip }: FieldSourceDotProps) {
  return (
    <Tooltip title={tooltip ?? `From ${SOURCE_LABEL[source]}`} placement="top" enterDelay={300}>
      <Box
        component="span"
        role={onClick ? "button" : undefined}
        aria-label={`Source: ${SOURCE_LABEL[source]}`}
        onClick={(event) => {
          // Don't trigger the InfoBox copy/expand modal.
          event.stopPropagation();
          onClick?.(event);
        }}
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor: SOURCE_COLOR[source],
          cursor: onClick ? "pointer" : "default",
        }}
      />
    </Tooltip>
  );
}
